import { Controller } from '@hotwired/stimulus'

// Bloques de la portada de cuentas que entran con una animación al llegar a la pantalla
// (rankings y línea de etapas, ENH-RNK-7023). Solo se esconden si hay JavaScript y no se
// ha pedido «reducir movimiento»: la clase con-animacion la pone este controlador, así que
// sin él el contenido se ve siempre.
export default class extends Controller {
  static values = { umbral: { type: Number, default: 0.2 } }

  connect () {
    const sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (sinMovimiento || !('IntersectionObserver' in window)) return

    this.element.classList.add('con-animacion')
    this.observador = new IntersectionObserver((entradas) => {
      if (!entradas.some((entrada) => entrada.isIntersecting)) return

      this.element.classList.add('is-visible')
      this.observador.disconnect()
    }, { threshold: this.umbralValue })
    this.observador.observe(this.element)
  }

  disconnect () {
    this.observador?.disconnect()
  }
}
